module.exports = __webpack_public_path__ + "img/logo.afebc85d.png";